import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CheckCircle, XCircle, ShieldCheck, IdentificationCard, MapPin } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

const VerifyAgent = () => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API}/api/public/verify/agent/${token}`);
        setData(r.ok ? await r.json() : { valid: false, message: 'Erreur réseau' });
      } catch {
        setData({ valid: false, message: 'Erreur réseau' });
      }
      setLoading(false);
    })();
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F172A]">
        <div className="text-[#94A3B8]">Vérification en cours...</div>
      </div>
    );
  }

  const valid = data?.valid;
  const fullName = [data?.prenom, data?.post_nom, data?.nom].filter(Boolean).join(' ') || data?.name || 'Agent';

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0F172A] via-[#111827] to-[#1F3A93] flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-[#0F172A] rounded-2xl shadow-2xl border border-[#1E293B] overflow-hidden" data-testid="verify-agent-card">
        {/* Bandeau statut */}
        <div className={`px-6 py-8 text-center ${valid ? 'bg-gradient-to-br from-[#10B981] to-[#059669]' : 'bg-gradient-to-br from-[#EF4444] to-[#B91C1C]'}`}>
          {valid ? (
            <>
              <CheckCircle size={64} weight="fill" className="text-white mx-auto mb-2" />
              <h1 className="text-2xl font-bold text-white">Carte authentique</h1>
              <p className="text-white/90 text-sm mt-1">Émise par Gazelle Security SARLU</p>
            </>
          ) : (
            <>
              <XCircle size={64} weight="fill" className="text-white mx-auto mb-2" />
              <h1 className="text-2xl font-bold text-white">Carte invalide</h1>
              <p className="text-white/90 text-sm mt-1">{data?.message || 'Cette carte n\'a pas été délivrée par Gazelle Security'}</p>
            </>
          )}
        </div>

        {/* Détails de l'agent */}
        {valid && (
          <div className="p-6 space-y-4">
            {data.photo_url && (
              <div className="flex justify-center">
                <img src={data.photo_url} alt={fullName} className="h-24 w-24 rounded-full object-cover border-4 border-[#F59E0B]" />
              </div>
            )}
            <div className="text-center">
              <h2 className="text-xl font-bold text-[#F8FAFC]">{fullName}</h2>
              <p className="text-[#94A3B8] text-sm">{data.fonction || 'Agent de sécurité'}</p>
            </div>

            <div className="space-y-2 pt-2 border-t border-[#1E293B]">
              <div className="flex items-center justify-between text-sm">
                <span className="text-[#94A3B8] flex items-center gap-1"><IdentificationCard size={14} /> Matricule</span>
                <span className="text-[#F8FAFC] font-mono font-semibold">{data.matricule || '—'}</span>
              </div>
              {data.assigned_site && (
                <div className="flex items-center justify-between text-sm">
                  <span className="text-[#94A3B8] flex items-center gap-1"><MapPin size={14} /> Site affecté</span>
                  <span className="text-[#F8FAFC]">{data.assigned_site}</span>
                </div>
              )}
              {data.issued_at && (
                <div className="flex items-center justify-between text-sm">
                  <span className="text-[#94A3B8]">Délivrée le</span>
                  <span className="text-[#F8FAFC]">{new Date(data.issued_at).toLocaleDateString('fr-FR')}</span>
                </div>
              )}
            </div>

            <div className="flex items-center gap-2 pt-3 border-t border-[#1E293B]">
              <ShieldCheck size={20} weight="duotone" className="text-[#10B981] flex-shrink-0" />
              <p className="text-xs text-[#94A3B8]">Vérification authentifiée par la plateforme Gazelle Security.</p>
            </div>
          </div>
        )}

        <div className="px-6 py-3 bg-[#1E293B]/50 text-center">
          <p className="text-xs text-[#64748B]">www.gazellesecurity.net</p>
        </div>
      </div>
    </div>
  );
};

export default VerifyAgent;
